import { Routes } from '@angular/router';
import { RuleCollectionDashboardComponent } from './components/rule-collection-dashboard.component';
import { RuleWorkspaceComponent } from './components/rule-workspace.component';


export const ruleRoutes: Routes = [
  {
    path: 'rule-collection-dashboard/:module',
    component: RuleCollectionDashboardComponent,
    data: {
      permissions: ['RuleModule.BusinessRule:View']
    }
  },
  {
    path: 'rule-collection/:rule',
    component: RuleWorkspaceComponent,
    data: {
      isNav: false,
      permissions: ['RuleModule.BusinessRule:View'],
      ruleListModel: []
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/businessRule/routes.config.ts